<template>
  <div class="workstation_edit_cidSid_pop" v-if="currThemeObj">
    <el-drawer
      title="筛选比赛"
      :visible.sync="drawerFlag"
      :with-header="false"
      :custom-class="'workstation_selectCidSid_pop'"
      @closed="closeDrawerEvent('cidSid')"
    >
      <div class="main">
        <div class="dataList">
          <span class="dataList_item">
            <span class="groupTitle" v-text="'选择赛事'"></span>
            <span class="item_main">
              <div
                class="dataList_item_row"
                v-for="item in paramsArr"
                :class="item.className ? item.className : ''"
                :key="item.key"
              >
                <span v-text="item.title"></span>
                <div class="row_right_item" v-if="item.type === 'Select'">
                  <el-select
                    v-model="item.value"
                    popper-class="popup_select_opt"
                    :popper-append-to-body="false"
                    placeholder="请选择"
                    @change="selectChange(item)"
                  >
                    <el-option
                      v-for="selecItem in item.list"
                      :key="selecItem.id"
                      :label="selecItem.name"
                      :value="selecItem.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="row_right_item" v-if="item.type === 'radio'">
                  <span class="optionItem_radio fadeIn">
                    <base_custom_switch
                      :currThemeObj="currThemeObj"
                      :data="item.list"
                      :flexDirection="'publicThemeDialog_switch'"
                      @clickSwitchEvent="clickSwitch"
                    ></base_custom_switch>
                  </span>
                  <!-- <span v-text="'保留本次选择'"></span> -->
                </div>
              </div>

              <div class="opreaBtns">
                <span
                  class="opreaBtns_cancel"
                  v-text="'取消'"
                  @click="closeDrawerEvent('cidSid')"
                ></span>
                <span
                  class="opreaBtns_save"
                  v-text="'保存'"
                  @click="saveParams()"
                ></span>
              </div>
            </span>
          </span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 选择 赛事 和 赛季 的弹窗
import { https_dataPoster_saveUseOpt } from '@api/platfrom_dataPoster_api.js'
import base_custom_switch from '@components/base/custom_switch.vue'
export default {
  name: 'workstation_edit_cidSid_pop',
  components: {
    base_custom_switch,
  },
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    currItem_params: {
      type: Object,
      default: () => ({
        analysisTypeId: '',
        competitionId: 'cid',
        seasonId: 'sid',
        sportsId: 'did',
        eventId: 'eid',
        date: 'dateId',
        designStyleId: '',
        posterAnalysis: {}, //小项对应的分析项id
        sportType: '',
        urlPrefix: '', //获取主题接口的根路径
      }),
    },
    competitionArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawerFlag: false,
      paramsArr: [
        {
          title: '赛事',
          key: 'competition',
          value: '',
          list: [],
          type: 'Select',
          className: '',
        },
        {
          title: '赛季',
          key: 'season',
          value: '',
          list: [],
          type: 'Select',
          className: '',
        },
        {
          type: 'radio',
          key: 'useOpt',
          title: '',
          value: '',
          list: [
            {
              id: '1',
              name: '保留当前选择',
              act: false,
              optId: 'saveCidSid',
            },
            // {
            //   id: '2',
            //   name: '单次生效',
            //   act: false,
            //   optId: 'broadcastList',
            // },
          ],
        },
      ],
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.drawerFlag = this.isOpen
      console.debug(
        'this.currItem_params:',
        this.currItem_params,
        this.competitionArr
      )
      if (this.currItem_params.competitionId && this.currItem_params.seasonId) {
        let paramsArr = JSON.parse(JSON.stringify(this.paramsArr))
        paramsArr[0].list = this.competitionArr.map((item) => {
          const seasonArr = item.seasons.map((sItem) => {
            return {
              id: sItem.seasonId,
              name: sItem.seasonName,
            }
          })
          if (item.competitionId === this.currItem_params.competitionId) {
            paramsArr[1].list = seasonArr
          }
          return {
            id: item.competitionId,
            name: item.competitionName,
            seasonArr,
          }
        })
        paramsArr[0].value = this.currItem_params.competitionId
        paramsArr[1].value = this.currItem_params.seasonId
        this.paramsArr = paramsArr
      }
    },
    posterEventHandler(data) {
      // 选中比赛，除非回调函数
      // type==='poster',区分页面视图用的；在这里换成新的词
      const { type, data: matchItem } = data

      this.$emit('changeMatchItemEvent', {
        type: 'actMatch',
        data: matchItem,
      })
      this.closeDrawerEvent('match')
    },
    closeDrawerEvent(state) {
      this.drawerFlag = false
      setTimeout(() => {
        let type = state ? state : 'pop'
        this.$emit('closeDoneEvent', {
          type,
        })
      }, 400)
    },
    selectChange(selectItem) {
      if (selectItem.key === 'competition') {
        let paramsArr = JSON.parse(JSON.stringify(this.paramsArr))
        console.debug('selectItem:', selectItem)
        selectItem.list.forEach((item) => {
          if (item.id === selectItem.value) {
            paramsArr[1].list = item.seasonArr
            paramsArr[1].value = item.seasonArr[0].id
          }
        })
        this.paramsArr = paramsArr
      }
    },
    clickSwitch(item) {
      console.debug(item)
      let paramsArr = JSON.parse(JSON.stringify(this.paramsArr))
      let optId = item.optId
      if (item.act) {
        this.useCidSidOpt = ''
      } else {
        this.useCidSidOpt = item.optId
      }
      paramsArr.forEach((optItem) => {
        if (optItem.key === 'useOpt') {
          optItem.list.forEach((switchItem) => {
            if (switchItem.id == item.id) {
              optItem.value = this.useCidSidOpt
              switchItem.act = !item.act
            } else {
              switchItem.act = false
            }
          })
        }
      })
      console.debug(this.useCidSidOpt)
      this.paramsArr = paramsArr
    },
    async saveParams() {
      const valArr = []
      this.paramsArr.forEach((item) => {
        valArr.push(item.value)
      })
      console.debug(valArr)
      if (valArr[2] && valArr[2] === 'saveCidSid') {
        await this.saveUseOpt(valArr[0], valArr[1])
      }
      this.$emit('saveParamsEvent', {
        data: valArr,
      })
      this.closeDrawerEvent('cidSid')
    },
    async saveUseOpt(competitionId, seasonId) {
      let params = {
        competitionId,
        seasonId,
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_dataPoster_saveUseOpt(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(res.data)
            //保存用户设置成功
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.workstation_edit_cidSid_pop {
  width: 100%;
  .dataList {
    padding: 0;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    align-content: flex-start;
    .dataList_item {
      position: relative;
      margin: 0;
      width: 39.406vw;
      height: 21.4vw;
      background-color: var(--mixtmt_greyColor8);
      border-radius: 0.556vw;
      &:nth-child(2n) {
        margin: 0 0 1.743vw 0;
      }
      .groupTitle {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 3.472vw;
        padding: 0 1.388vw;
        font-size: 1.25vw;
        font-weight: bold;
        color: var(--mixtmt_greyColor3);
      }
    }

    .dataList_item {
      position: relative;
      padding-top: 3.472vw;
      border: 1px solid var(--mixtmt_greyColor7);
      .item_main {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        padding: 1.388vw 1.388vw 0 1.388vw;
        width: 100%;
        height: 100%;
        background-color: var(--mixtmt_whiteColor);
        border-radius: 0 0 0.556vw 0.556vw;
        .dataList_item_row {
          width: 100%;
          margin-bottom: 1.388vw;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          &.alignItemsStart {
            align-items: flex-start;
            & > span {
              padding-top: 0.208vw;
            }
          }
          .row_right_item {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            &.flexColumn {
              flex-direction: column;
              align-items: flex-start;
            }
            .ceil {
              padding-left: 0.694vw;
              font-size: 0.972vw;
              font-weight: 600;
              color: var(--mixtmt_greyColor2);
            }
          }
          & > span {
            width: 6.94vw;
            padding-right: 0.694vw;
            text-align: right;
            font-size: 0.972vw;
            font-weight: 600;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
      .item_btns {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 3.472vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .btn {
          margin-right: 1.388vw;
          width: 6.94vw;
          height: 1.94vw;
          border: none;
          border-radius: 0.138vw;
          font-size: 0.833vw;
          font-weight: 500;
          line-height: 1.94vw;
          text-align: center;
          background: var(--mixtmt_whiteColor);
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
        }
        .title {
          padding: 0 1.388vw;
          width: 100%;
          font-size: 0.972vw;
          font-weight: 500;
          line-height: 1.94vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
    .optionItem_radio {
      opacity: 1;
      &.fadeIn {
        animation: fadeIn 0.6s linear;
      }
    }
    .opreaBtns {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: auto;
      padding-bottom: 2.083vw;
      .opreaBtns_save,
      .opreaBtns_cancel {
        width: 6.94vw;
        height: 2.5vw;
        line-height: 2.5vw;
        font-size: 1.11vw;
        text-align: center;
        border-radius: 0.2778vw;
      }
      .opreaBtns_save {
        background-color: var(--mixtmt_subColor1_1);
        color: var(--mixtmt_whiteColor);
      }
      .opreaBtns_cancel {
        margin-right: 1.11vw;
        background-color: var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor2);
      }
    }
  }
}
.mixtmt_pc .workstation_edit_cidSid_pop {
  .dataList {
    .opreaBtns {
      .opreaBtns_save,
      .opreaBtns_cancel {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.workstation_selectCidSid_pop {
  width: 40% !important;
  padding: 1.388vw 0.694vw;
  .base_select_opt.el-popper[x-placement^='bottom'] {
    position: absolute !important;
    top: 4.6vw !important;
  }
  .dataList_item {
    .el-input__inner {
      height: 2.778vw;
      line-height: 2.778vw;
      border-radius: 0.278vw;
      padding: 0 1.041vw;
    }
    .el-select-dropdown {
      border-radius: 0.69vw;
    }
    .el-select-dropdown__item {
      font-size: 1.111vw;
      height: 2.778vw;
      line-height: 2.778vw;
      &.selected,
      &.hover,
      &.active,
      &.visited {
        color: var(--mixtmt_subColor1_1);
        background-color: var(--mixtmt_subColor1_2);
      }
    }
  }
}
</style>
